<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-container class="container" fluid>
        <Breadcrumbs :items="items" />

        <v-card class="mx-auto" max-width="1000" elevation="1">
          <v-toolbar color="#343F53">
            <v-card-title
              class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
            >
              <span style="color: white">MENSAGENS</span>
            </v-card-title>
          </v-toolbar>

          <v-card-text>
            <v-card class="pa-4" elevation="0" rounded="lg">
              <v-row>
                <v-col cols="6"></v-col>
                <v-col cols="6" class="px-0 pb-0"
                  ><v-text-field
                    v-model="search"
                    label="Filtrar"
                    variant="outlined"
                    density="compact"
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    rounded="lg"
                    class="bg-white"
                /></v-col>
              </v-row>
            </v-card>
            <v-data-table
              :headers="headers"
              :items="filteredItems"
              :items-per-page="itemsPerPage"
              :loading="loading"
              loading-text="Buscando..."
              :search="search.toLowerCase()"
              items-per-page-text="Mensagens por página"
              :pageText="'{0}-{1} de {2}'"
              :sort-by="[{ key: 'id', order: 'desc' }]"
            >
              <template #item.imagem="{ item }">
                <div>
                  <img
                    v-if="item.imagem"
                    :src="item.imagem"
                    alt="Foto do Perfil"
                    class="foto_perfil"
                  />
                </div>
              </template>

              <template #item.conteudo="{ item }">
                <div class="d-flex flex-column my-2">
                  <div class="d-flex justify-content-between">
                    <span><strong>Usuário:</strong> {{ item.nome }}</span>
                  </div>
                  <div
                    class="mensagem-container d-flex justify-content-between"
                  >
                    <span><strong>Mensagem:</strong> {{ item.descricao }}</span>
                  </div>
                </div>
              </template>

              <template #item.status="{ item }">
                <div class="d-flex flex-row flex-md-row my-4 align-center">
                  <v-chip
                    :color="item.publicado ? 'green' : 'red'"
                    class="text-white mb-5 mr-3"
                    label
                    size="small"
                  >
                    {{ item.publicado ? "Aprovado" : "Desaprovado" }}
                  </v-chip>
                </div>
              </template>
              <template #item.acoes="{ item }">
                <div class="ml-md-4 d-flex flex-row align-start justify-center">
                  <v-switch
                    v-model="item.publicado"
                    color="#343F53"
                    @click="editarStatusMensagem(item.id, !item.publicado)"
                  />
                  <v-btn
                    rounded="lg"
                    variant="text"
                    @click="gerenciarMensagem(item)"
                    color="#343F53"
                    class="d-flex align-center justify-center mt-2"
                    disabled
                  >
                    <v-icon size="28">mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </template>
              <template #no-data>
                <div class="text-center py-4 text-medium-emphasis">
                  Nenhuma mensagem encontrada.
                </div>
              </template>
            </v-data-table>
            <v-col cols="12" class="text-end"> </v-col>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
  <v-dialog v-model="dialog" max-width="600">
    <v-card>
      <v-toolbar color="#343F53">
        <v-card-title class="text-h5 grey lighten-2">
          <span class="font-weight-bold">Edição Mensagem</span>
        </v-card-title>
      </v-toolbar>
      <v-card-text>
        <v-row no-gutter>
          <v-col cols="12" class="py-0">
            <v-textarea
              label="Mensagem"
              rows="4"
              outlined
              :counter="160"
              maxlength="160"
              color="#343F53"
              class="mt-4"
              v-model="mensagemEditar.descricao"
            ></v-textarea>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-text-field
              label="Nome"
              outlined
              color="#343F53"
              class="mt-4"
              v-model="mensagemEditar.nome"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false" class="botao" color="#343F53">
          <v-icon>mdi-close-circle</v-icon> Fechar</v-btn
        >
        <v-btn variant="flat" class="botao" color="#343F53"
          ><v-icon>mdi-check</v-icon> Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
</template>

<script>
import Footer from "./Footer.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import { useToast } from "vue-toastification";
import Sidebar from "@/components/restrito/Sidebar.vue";
import Navbar from "@/components/restrito/Navbar.vue";
import Breadcrumbs from "@/components/utils/Breadcrumbs.vue";
const toast = useToast();
export default {
  name: "Mensagens",
  components: {
    Navbar,
    Sidebar,
    Footer,
    Breadcrumbs,
  },
  mounted() {
    this.idDespedida = this.$route.params.id;
    this.buscarMensagens();
  },
  computed: {
    filteredItems() {
      return this.serverItems.map((item) => ({
        ...item,
        conteudo: `${item.nome} ${item.descricao}`.toLowerCase(),
      }));
    },
  },
  methods: {
    gerenciarMensagem(item) {
      this.dialog = true;
      this.mensagemEditar = item;
      console.log("Gerenciar mensagem com ID:", item);
    },
    buscarMensagens() {
      this.loading = true;
      http
        .get("homenagem/homenagem-despedida/" + this.idDespedida, {
          headers: authHeader(),
        })
        .then((response) => {
          this.serverItems = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao buscar mensagens:", error);
          this.loading = false;
        });
    },
    editarStatusMensagem(idMensagem, status) {
      const statusToast = status;
      http
        .put(
          "homenagem/update-status-homenagem/" + idMensagem + "/" + status,
          null,
          {
            headers: authHeader(),
          }
        )
        .then((response) => {
          this.dialog = false;
          this.buscarMensagens();
          console.log("Mensagem editada com sucesso:", response.data);
          toast.success(
            `Mensagem ${statusToast ? "ativada" : "desativada"} com sucesso!`
          );
        })
        .catch((error) => {
          console.error("Erro ao editar mensagem:", error);
        });
    },
  },
  data() {
    return {
      items: [
        {
          title: "Início",
          disabled: false,
          href: "/admin/despedidas",
        },
        {
          title: "Mensagens",
          disabled: true,
        },
      ],
      itemsPerPage: 10,
      search: "",
      loading: false,
      dialog: false,
      idDespedida: null,
      headers: [
        { text: "Imagem", value: "imagem", title: "Imagem", sortable: false },
        {
          text: "Conteúdo",
          value: "conteudo",
          title: "Conteúdo",
          sortable: false,
        },
        { text: "Status", value: "status", title: "Status", sortable: false },
        {
          text: "Ações",
          value: "acoes",
          title: "Ações",
          sortable: false,
          align: "center",
        },
      ],
      mensagemEditar: {},
      serverItems: [],
    };
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
  padding-top: 2rem;
}
.foto_perfil {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
}

.mensagem-container {
  max-width: 300px;
  margin-top: 10px;
  word-wrap: break-word;
  white-space: normal;
}

.botao {
  margin-bottom: 0.6rem;
  margin-right: 0.4rem;
  font-weight: bold;
}

/* Garantir que os estilos do Sidebar sejam aplicados corretamente */
:deep(.sidebar .menu-item .v-list-item-title) {
  font-size: 1rem !important;
  font-weight: 400 !important;
}
</style>
